import { DamperType, UserInput } from 'src/actuators/user-input/types.ts';
import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants.ts';
import { RegionsEnum } from 'src/generated/operations.ts';

export const isFilled = ({ inputState, currentRegion, selectedActuatorType } : {
    inputState: UserInput;
    selectedActuatorType: ActuatorTypes;
    currentRegion: RegionsEnum;
}): boolean => {
    if (currentRegion === RegionsEnum.Am &&
        inputState.force &&
        inputState.force?.length > 0) {
        return true;
    }
    const isLinearFilled = selectedActuatorType === ActuatorTypes.Linear
        ? inputState.crankArmLength.length > 0 : true;
    switch (inputState.damper) {
        case DamperType.Rectangular: {
            return inputState.areaOrDiameter.length > 0 &&
                inputState.blade !== null &&
                isLinearFilled;
        }
        case DamperType.Round: {
            if (currentRegion === RegionsEnum.Am) {
                return inputState.areaOrDiameter.length > 0 && isLinearFilled;
            }
            return inputState.areaOrDiameter.length > 0 &&
                inputState.roundDumper !== null;
        }
        default:
            return false;
    }
};
